import * as React from 'react';
import { render, unmountComponentAtNode } from 'react-dom';

export const mountModule = (Component: React.ComponentType, mount: HTMLElement): (() => void) => {
	render(<Component />, mount);

	return () => {
		unmountComponentAtNode(mount);
	};
};
